import { useContext } from 'react'

import { EnvironmentTypeContext } from './EnvironmentTypeContext'

export const useEnvironmentTypeContext = () =>
  useContext(EnvironmentTypeContext)
